import {VirtualTeamsConstant as constants} from '../../../_constants/VirtualTeams/VirtualTeams.constants';

const initialState = { team_list_loading : true, team_list_data: [], team_list_error: false };

export function virtualTeamList(state = initialState, action) {
   
    switch (action.type) {
        case constants.VIRTUAL_TEAM_LIST_LOADING:
            return {
                getAnalyzeLoading: true,
                data: [],
                error: false
            };
        case constants.VIRTUAL_TEAM_LIST_DATA:
            return {
                getAnalyzeLoading: false,
                data: action.virtual_list_list,
                error: false
            };
        case constants.VIRTUAL_TEAM_LIST_ERROR:
            return {
                getAnalyzeLoading: false,
                data: [],
                error: true
            };
        default:
            return state
    }
}


const initialStateListMain = { team_listMain_loading : true, team_listMain_data: [], team_listMain_error: false };

export function virtualTeamListMain(state = initialStateListMain, action) {
   
    switch (action.type) {
        case constants.VIRTUAL_TEAM_LISTMAIN_LOADING:
            return {
                team_listMain_loading: true,
                team_listMain_data: [],
                team_listMain_error: false
            };
        case constants.VIRTUAL_TEAM_LISTMAIN_DATA:
            return {
                team_listMain_loading: false,
                team_listMain_data: action.virtual_team_list,
                team_listMain_error: false
            };
        case constants.VIRTUAL_TEAM_LISTMAIN_ERROR:
            return {
                team_listMain_loading: false,
                team_listMain_data: [],
                team_listMain_error: true
            };
        default:
            return state
    }
}

const initialStateEdit = { team_edit_loading : true, team_edit_data: [], team_edit_error: false };

export function virtualTeamEdit(state = initialStateEdit, action) {
   
    switch (action.type) {
        case constants.VIRTUAL_TEAM_EDIT_LOADING:
            return {
                team_edit_loading: true,
                team_edit_data: [],
                team_edit_error: false
            };
        case constants.VIRTUAL_TEAM_EDIT_DATA:
            return {
                team_edit_loading: false,
                team_edit_data: action.virtual_edit,
                team_edit_error: false
            };
        case constants.VIRTUAL_TEAM_EDIT_ERROR:
            return {
                team_edit_loading: false,
                team_edit_data: [],
                team_edit_error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/VirtualTeams/VirtualTeamList/VirtualTeamList.reducer.js